export const ActionTypes = {
  USER_PROFILE_USER_FETCH_DATA: "USER_PROFILE_USER_FETCH_DATA",
  USER_PROFILE_USER_FETCH_DATA_SUCCESS: "USER_PROFILE_USER_FETCH_DATA_SUCCESS",

  USER_PROFILE_USER_ID_FETCH_DATA: "USER_PROFILE_USER_ID_FETCH_DATA",
  USER_PROFILE_USER_ID_FETCH_DATA_SUCCESS:
    "USER_PROFILE_USER_ID_FETCH_DATA_SUCCESS",

  USER_PROFILE_SAVE_USER_DATA: "USER_PROFILE_SAVE_USER_DATA",
  USER_PROFILE_SAVE_USER_DATA_SUCCESS: "USER_PROFILE_SAVE_USER_DATA_SUCCESS",

  UNREGISTER_USER_SAVE_DATA: "UNREGISTER_USER_SAVE_DATA",
  UNREGISTER_USER_SAVE_DATA_SUCCESS: "UNREGISTER_USER_SAVE_DATA_SUCCESS",

  REGISTER_USER_SAVE_ROLE_DATA: "REGISTER_USER_SAVE_ROLE_DATA",
  REGISTER_USER_SAVE_ROLE_DATA_SUCCESS: "REGISTER_USER_SAVE_ROLE_DATA_SUCCESS",

  REGISTER_USER_SAVE_SELECTED_ROLE_DATA:
    "REGISTER_USER_SAVE_SELECTED_ROLE_DATA",

  USER_PROFILE_SETTING_USER_ID_DATA: "USER_PROFILE_SETTING_USER_ID_DATA",
  USER_PROFILE_SETTING_USER_ID_DATA_SUCESS:
    "USER_PROFILE_SETTING_USER_ID_DATA_SUCESS",

  USER_PROFILE_UPDATE_SETTING: "USER_PROFILE_UPDATE_SETTING",
  USER_PROFILE_UPDATE_SETTING_SUCCESS: "USER_PROFILE_UPDATE_SETTING_SUCCESS",

  USER_PROFILE_SETTING_PAGE_SHOW: "USER_PROFILE_SETTING_PAGE_SHOW",
  USER_PROFILE_SUPPLIER_DETAILS: "USER_PROFILE_SUPPLIER_DETAILS",
  USER_PROFILE_DELETE_USER_PROFILE: "USER_PROFILE_DELETE_USER_PROFILE",
  USER_PROFILE_GRID_ACTIONS: "USER_PROFILE_GRID_ACTIONS",

  FETCH_IS_AUTHETICATED: "COMMON_FETCH_IS_AUTHETICATED",
  FETCH_IS_AUTHETICATED_SUCCESS: "COMMON_FETCH_IS_AUTHETICATED_SUCCESS",
  RESET_IS_AUTHETICATED: "COMMON_RESET_IS_AUTHETICATED",

  USER_PROFILE_SAVE_USER_ACCESS_REQUEST_DATA: "USER_PROFILE_SAVE_USER_ACCESS_REQUEST_DATA",
  USER_PROFILE_SAVE_USER_ACCESS_REQUEST_DATA_SUCCESS: "USER_PROFILE_SAVE_USER_ACCESS_REQUEST_DATA_SUCCESS",

  USER_PROFILE_ACCESS_REQUEST_SENT_SUCCESS: "USER_PROFILE_ACCESS_REQUEST_SENT_SUCCESS",

};

export const GET_ALL_USER_PROFILE_DETAILS: string = `/UserDetails/GetUserDetailsByUserNameOrId/-1`;
export const GET_USER_PROFILE_DETAILS: string = `/UserDetails/GetUserDetailsByUserNameOrId`;
export const POST_USER_PROFILE_DETAILS: string = `/UserDetails/SaveUserDetails`;
export const PUT_USER_PROFILE_DETAILS: string = `/UserDetails/UpdateUserDetails`;
export const POST_USER_PROFILE_SETTING: string = `/api/UserDetails/UpdateUserProfileSettings`;
export const DELETE_USER_PROFILE: string = `/UserDetails/DeleteUser?id=`;
export const GET_IS_AUTHETICATED: string = `/accounts/IsAuthenticated`;
export const POST_USER_ACCESS_REQUEST: string = `/UserDetails/AccessRequest`;
